import React, { useEffect, useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { AppLogo } from '../assets';
import {
  Avatar,
  Badge,
  Box,
  Drawer,
  Grid,
  IconButton,
  List,
  ListItem,
  Menu,
  MenuItem,
  Modal,
} from '@mui/material';
import { routesName } from '../constants/routes-name';
import {
  ChevronRight,
  Close,
  MailOutline,
  Menu as MenuIcon,
  Notifications,
  PlaceOutlined,
} from '@mui/icons-material';
import { useSelector } from 'react-redux';
import * as Images from '../assets';
import { LightBlueButton } from '../components';
import CookiesPopup, {
  CookiesPlolicy,
  PrivacyPolicy,
} from './components/CookiesPopup';
import moment from 'moment';
import { ApiManager } from '../services/api';
import useScreen from '../hooks/useScreen';

function Component() {
  const location = useLocation();
  const navigate = useNavigate();
  const { width } = useScreen();
  const { user } = useSelector(({ user }) => user);
  //const { scrolled } = useScreen();
  const [scrolled, setScrolled] = useState(
    document.getElementById('hp-root')?.scrollTop || 0
  );
  const [open, setOpen] = useState(false);
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const [openPrivacyPolicy, setOpenPrivacyPolicy] = useState(false);
  const handleOpenPrivacyPolicy = () => {
    setOpenPrivacyPolicy(true);
  };
  const handleClosePrivacyPolicy = () => {
    setOpenPrivacyPolicy(false);
  };

  const [openCookiePolicy, setOpenCookiePolicy] = useState(false);
  const handleOpenCookiePolicy = () => {
    setOpenCookiePolicy(true);
  };
  const handleCloseCookiePolicy = () => {
    setOpenCookiePolicy(false);
  };

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', ''); // Get the id without the `#`
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      const id = 'hp-root';
      const element = document.getElementById(id);
      if (element) {
        element.scroll({
          top: 0,
          behavior: 'smooth',
        });
      }
    }
  }, [location]);

  const menuItems = [
    {
      name: 'Pricing',
      path: routesName.pricing,
    },
    {
      name: 'How It Works',
      path: routesName.home + '#Howitworks',
    },
    {
      name: 'About',
      path: routesName.about,
    },
    {
      name: 'BUSINESS OPPORTUNITIES',
      path: user ? routesName.tenderListing : routesName.tenders,
    },
    {
      name: 'Contact',
      path: routesName.contact,
    },
    {
      name: 'PUBLISH TENDER (UN/NGO)',
      path: routesName.ngounStaff,
    },
  ];

  const [notifications, setNotifications] = useState();
  const [anchorNotification, setAnchorNotification] = useState(null);
  const openNotification = Boolean(anchorNotification);

  const handleClickNotification = (event) => {
    setAnchorNotification(event.currentTarget);
  };

  const handleCloseNotification = () => {
    setAnchorNotification(null);
  };

  const getMyNotifications = async () => {
    if (user) {
      const res = await ApiManager.getMyNotifications();
      if (res.status === 200 && res.data?.result) {
        setNotifications(res.data?.result);
      }
    }
  };

  useEffect(() => {
    if (user) {
      getMyNotifications();

      const interval = setInterval(() => {
        getMyNotifications();
      }, 30000);

      return () => clearInterval(interval);
    }
  }, []);

  const [anchorProfile, setAnchorProfile] = useState(null);
  const openProfile = Boolean(anchorProfile);
  const handleClickProfile = (event) => {
    setAnchorProfile(event.currentTarget);
  };
  const handleCloseProfile = () => {
    setAnchorProfile(null);
  };

  const messageNotification = (message, index) => {
    return (
      <div key={index} className="border-b-gray-400 border-b">
        <MenuItem
          onClick={() => {
            ApiManager.notificationMarkAsRead(message._id);
            navigate(`${routesName.openChat}?mid=${message?.chat?.chatGroup}`);
            handleCloseNotification();
            getMyNotifications();
          }}
        >
          <div>
            <div className="text-wrap text-sm">
              <span className="font-bold">{message.from?.name}</span> has sent a
              message against{' '}
              <span className="font-bold">{message.tender?.tenderTitle}</span>
            </div>
            <div className="text-xs text-right mt-1">
              {moment(message?.createdAt).fromNow()}
            </div>
          </div>
        </MenuItem>
      </div>
    );
  };

  const bidNotification = (bid, index) => {
    return (
      <div key={index} className="border-b-gray-400 border-b">
        <MenuItem
          onClick={() => {
            ApiManager.notificationMarkAsRead(bid._id);
            navigate(`${routesName.viewTenderPath}${bid.tender._id}?tab=2`);
            handleCloseNotification();
            getMyNotifications();
          }}
        >
          <div>
            <div className="text-wrap text-sm">
              <span className="font-bold">{bid.from?.name}</span> has submitted
              a bid against{' '}
              <span className="font-bold">{bid.tender?.tenderTitle}</span>
            </div>
            <div className="text-xs text-right mt-1">
              {moment(bid?.createdAt).fromNow()}
            </div>
          </div>
        </MenuItem>
      </div>
    );
  };

  const interestedInTenderNotification = (interest, index) => {
    return (
      <div key={index} className="border-b-gray-400 border-b">
        <MenuItem
          onClick={() => {
            ApiManager.notificationMarkAsRead(interest._id);
            navigate(
              `${routesName.viewTenderPath}${interest.tender._id}?tab=2`
            );
            handleCloseNotification();
            getMyNotifications();
          }}
        >
          <div>
            <div className="text-wrap text-sm">
              <span className="font-bold">{interest.from?.name}</span> showes
              interest in{' '}
              <span className="font-bold">{interest.tender?.tenderTitle}</span>
            </div>
            <div className="text-xs text-right mt-1">
              {moment(interest?.createdAt).fromNow()}
            </div>
          </div>
        </MenuItem>
      </div>
    );
  };

  return (
    <div
      className="h-screen bg-white overflow-y-auto flex flex-col justify-between"
      id="hp-root"
      onScroll={() => {
        setScrolled(document.getElementById('hp-root')?.scrollTop || 0);
      }}
    >
      <div>
        <div
          className={`sticky  shadow-xl  top-[-1px] z-[2] ${
            scrolled < 55 ? 'transpatent' : 'bg-[var(--dark-blue)]'
          }`}
        >
          <div className="bg-[var(--dark-blue)] flex flex-wrap justify-between gap-4">
            <div className="text-white text-xs px-7 py-2">
              {/* <a href="mailto:info@aid-link.com">Email: info@aid-link.com</a> */}
              <Link to={routesName.home}>
                <img alt="logo" src={AppLogo} className="h-[25px]" />
              </Link>
            </div>
            <div className="flex gap-2 items-center">
              {user && (
                <Link to={'#'}>
                  <LightBlueButton sx={{ paddingBottom: '0px' }} size="small">
                    Signup to Alert Service
                  </LightBlueButton>
                </Link>
              )}

              {!user && (
                <Link to={routesName.signupSupplier}>
                  <LightBlueButton sx={{ paddingBottom: '0px' }} size="small">
                    Get started
                  </LightBlueButton>
                </Link>
              )}
              {!user && (
                <Link to={routesName.login}>
                  <LightBlueButton sx={{ paddingBottom: '0px' }} size="small">
                    Log in
                  </LightBlueButton>
                </Link>
              )}
              {user && (
                <Link to={routesName.dashboard}>
                  <LightBlueButton sx={{ paddingBottom: '0px' }} size="small">
                    Go to dashboard
                  </LightBlueButton>
                </Link>
              )}
            </div>
          </div>
          {/*    <div className="py-6 bg-gradient-to-r from-blue-600 via-blue-500 to-blue-400">
        <div className="container mx-auto px-4"> */}
          <div className={`h-[70px] shadow-xl  top-[-1px] z-[2] ${'bg-white'}`}>
            <div className="flex justify-between items-center gap-2 h-full">
              <div className="flex-1 flex items-center h-full">
                {/* <div className="px-4 py-1 bg-[var(--dark-blue)]">
                <Link to={routesName.home}>
                  <img
                    alt="logo"
                    src={AppLogo}
                    width={240}
                    className="h-[60px]"
                  />
                  <div className="flex items-center justify-center gap-4"></div>
                </Link>
              </div> */}
                <div
                  className={`h-full ${
                    width < 1200 ? 'flex-1 flex items-center justify-end' : ''
                  }`}
                >
                  <div
                    className={`${width > 1200 ? 'md:block' : 'hidden'} h-full`}
                  >
                    <div className="flex items-center justify-center h-full uppercase">
                      {menuItems.map((item, index) => (
                        <Link
                          key={index}
                          to={item.path}
                          className={`h-full flex items-center text-sm text-center px-7 py-2 font-[600] tracking-[1px] cursor-pointer  hover:text-white hover:bg-[var(--dark-blue)] ${
                            location.pathname === item.path
                              ? 'bg-[var(--dark-blue)] text-white'
                              : 'text-[var(--blue)]'
                          }`}
                        >
                          {item.name}
                        </Link>
                      ))}
                    </div>
                  </div>

                  <div
                    className={`${width < 1200 ? 'block' : 'hidden'} h-full`}
                  >
                    <div className="flex flex-col items-center justify-center h-full">
                      <IconButton
                        size="small"
                        sx={{
                          backgroundColor: 'var(--blue)',

                          '&:hover': {
                            backgroundColor: 'var(--dark-blue)',
                          },
                        }}
                        id="basic-button"
                        onClick={toggleDrawer(true)}
                      >
                        <MenuIcon className="text-white" />
                      </IconButton>
                    </div>
                    <Drawer
                      anchor={'right'}
                      open={open}
                      onClose={toggleDrawer(false)}
                      sx={{
                        '& .MuiPaper-root': {
                          backgroundColor: 'var(--blue)',
                        },
                      }}
                    >
                      <Box
                        sx={{ width: 250, mt: 6 }}
                        role="presentation"
                        onClick={toggleDrawer(false)}
                      >
                        <List>
                          {menuItems.map((item, index) => (
                            <ListItem disablePadding key={index}>
                              <Link
                                to={item.path}
                                className="text-sm text-white hover:text-black hover:bg-blue-200 text-center px-4 py-4 font-bold text-center cursor-pointer w-full"
                              >
                                {item.name}
                              </Link>
                            </ListItem>
                          ))}

                          {!user && (
                            <ListItem className="mt-5" disablePadding>
                              <div className="w-full flex justify-center">
                                <Link
                                  to={routesName.pricing}
                                  className="text-sm text-white border border-1 border-white text-center px-4 py-2 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                                >
                                  Log in
                                </Link>
                              </div>
                            </ListItem>
                          )}
                          {!user && (
                            <ListItem className="mt-5" disablePadding>
                              <div className="w-full flex justify-center">
                                <Link
                                  to={routesName.login}
                                  className="text-sm text-white border border-1 border-white text-center px-4 py-2 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                                >
                                  Get started
                                </Link>
                              </div>
                            </ListItem>
                          )}
                          {user && (
                            <ListItem className="mt-5" disablePadding>
                              <div className="w-full flex justify-center">
                                <Link
                                  to={routesName.dashboard}
                                  className="text-sm text-white border border-1 border-white text-center px-4 py-2 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
                                >
                                  Go to dashboard
                                </Link>
                              </div>
                            </ListItem>
                          )}
                        </List>
                      </Box>
                    </Drawer>
                  </div>
                </div>
              </div>
              {user && (
                <div className="mr-2 flex gap-2" style={{}}>
                  <IconButton
                    id="notification-button"
                    size="small"
                    aria-controls={
                      openNotification ? 'notification-menu' : undefined
                    }
                    sx={{
                      backgroundColor: 'var(--blue)',

                      '&:hover': {
                        backgroundColor: 'var(--dark-blue)',
                      },
                    }}
                    aria-haspopup="true"
                    aria-expanded={openNotification ? 'true' : undefined}
                    onClick={handleClickNotification}
                  >
                    {Array.isArray(notifications) &&
                    notifications.length > 0 ? (
                      <Badge
                        /* variant="dot" */
                        badgeContent={
                          notifications.length < 100
                            ? notifications.length
                            : '99+'
                        }
                        color="error"
                        invisible={false}
                        style={{ height: '25px', width: '25px' }}
                      >
                        <span>
                          <Notifications
                            style={{ height: '25px', width: '25px' }}
                            sx={{ color: '#fff' }}
                          />
                        </span>
                      </Badge>
                    ) : (
                      <Notifications size="small" sx={{ color: '#fff' }} />
                    )}
                  </IconButton>

                  <IconButton
                    id="profile-button"
                    aria-controls={openProfile ? 'profile-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={openProfile ? 'true' : undefined}
                    onClick={handleClickProfile}
                    size="small"
                    sx={{
                      backgroundColor: 'var(--blue)',
                      padding: '0px',
                      '&:hover': {
                        backgroundColor: 'var(--dark-blue)',
                      },
                    }}
                  >
                    <Avatar
                      style={{
                        height: '34px',
                        width: '34px',
                        backgroundColor: 'inherit',
                      }}
                    >
                      {/* {`${user?.name}`.trim().charAt(0)} */}
                    </Avatar>
                  </IconButton>
                </div>
              )}
            </div>
          </div>
        </div>

        <Outlet />
      </div>
      <div
        className="bg-[var(--dark-blue)] float-bottom"
        style={{
          position: 'relative',
          backgroundImage: `url('${Images.homePage9}')`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center right',
          backgroundSize: '300px',
          //opacity: '.34',
          transition: 'background 0.3s, border-radius 0.3s, opacity 0.3s',
        }}
      >
        <CookiesPopup />
        <div
          className="px-6 py-12"
          style={{
            background: 'inherit',
            zIndex: 2,
          }}
        >
          <Grid container spacing={3}>
            <Grid item md={4} xs={12}>
              <div className="text-white text-white flex flex-col gap-6">
                <div className="text-3xl font-bold">
                  <img alt="logo" src={AppLogo} width={200} />
                </div>
                <div className="text-sm">
                  Save time searching for new business oppertunities in the
                  humanitarian sector{' '}
                </div>
              </div>
            </Grid>
            <Grid item lg={2} md={3} xs={12}>
              <div className="text-white flex flex-col gap-6">
                <div className="font-bold text-xl">Contact Us</div>

                <div className=" flex flex-col gap-2">
                  <div className="hover:text-[var(--blue)] text-sm flex items-center gap-1">
                    <div>
                      <PlaceOutlined fontSize="small" />
                    </div>
                    <div>Stensballegaardvej 23 8700 Horsens, Denmark</div>
                  </div>

                  {/* <div className="hover:text-[var(--blue)] text-sm flex items-center gap-1">
                    <div>
                      <MailOutline fontSize="small" />
                    </div>
                    <a href="mailto:info@aid-link.com">info@aid-link.com</a>
                  </div> */}
                  <div className="hover:text-[var(--blue)] text-sm flex items-center gap-1">
                    <div>
                      <MailOutline fontSize="small" />
                    </div>
                    <Link to={routesName.contact}>Message us</Link>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item lg={2} md={3} xs={12}>
              <div className="text-white flex flex-col gap-6">
                <div className="font-bold text-xl">Information</div>

                <div className=" flex flex-col gap-2">
                  <div className="hover:text-[var(--blue)] text-sm flex items-center gap-1">
                    <div>
                      <ChevronRight fontSize="small" />
                    </div>
                    <Link to={routesName.termsAndConditions}>
                      Terms & Conditions
                    </Link>
                  </div>
                  <div className="hover:text-[var(--blue)] text-sm flex items-center gap-1">
                    <div>
                      <ChevronRight fontSize="small" />
                    </div>
                    <div
                      onClick={() => handleOpenPrivacyPolicy()}
                      className="cursor-pointer"
                    >
                      Privacy Policy
                    </div>
                  </div>
                  <div className="hover:text-[var(--blue)] text-sm flex items-center gap-1">
                    <div>
                      <ChevronRight fontSize="small" />
                    </div>
                    <div
                      onClick={() => handleOpenCookiePolicy()}
                      className="cursor-pointer"
                    >
                      Cookie Policy
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>

      <Modal
        open={openCookiePolicy}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { lg: 800, md: 600, sm: 450, xs: 320 },
            bgcolor: 'background.paper',
            boxShadow: 24,
          }}
          className="rounded-md"
        >
          <div className="bg-[var(--blue)] px-7 py-7 flex flex-wrap justify-between items-center">
            <img src={Images.AppLogo} alt="logo" width={150} />

            <IconButton onClick={() => handleCloseCookiePolicy()}>
              <Close fontSize="small" />
            </IconButton>
          </div>
          <hr style={{ border: 'o.5px solid #00000013' }} />

          <div className="relative min-h-[270px] max-h-[560px] overflow-y-auto">
            <CookiesPlolicy onClose={handleCloseCookiePolicy} />
          </div>
        </Box>
      </Modal>

      <Modal
        open={openPrivacyPolicy}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { lg: 800, md: 600, sm: 450, xs: 320 },
            bgcolor: 'background.paper',
            boxShadow: 24,
          }}
          className="rounded-md"
        >
          <div className="bg-[var(--blue)] px-7 py-7 flex flex-wrap justify-between items-center">
            <img src={Images.AppLogo} alt="logo" width={150} />

            <IconButton onClick={() => handleClosePrivacyPolicy()}>
              <Close fontSize="small" />
            </IconButton>
          </div>
          <hr style={{ border: 'o.5px solid #00000013' }} />

          <div className="relative min-h-[270px] max-h-[560px] overflow-y-auto">
            <PrivacyPolicy onClose={handleClosePrivacyPolicy} />
          </div>
        </Box>
      </Modal>

      <Menu
        id="notification-menu"
        anchorEl={anchorNotification}
        open={openNotification}
        onClose={handleCloseNotification}
        MenuListProps={{
          'aria-labelledby': 'notification-button',
        }}
      >
        <div className="max-w-60">
          {Array.isArray(notifications) && notifications.length > 0 ? (
            notifications.map((item, index) => {
              if (item.type === 'message') {
                return messageNotification(item, index);
              }
              if (item.type === 'bid') {
                return bidNotification(item, index);
              }
              if (item.type === 'interested-in-tender') {
                return interestedInTenderNotification(item, index);
              }
            })
          ) : (
            <div className="min-w-72 px-4 py-2">Notification</div>
          )}
        </div>
      </Menu>
      <Menu
        id="profile-menu"
        anchorEl={anchorProfile}
        open={openProfile}
        onClose={handleCloseProfile}
        MenuListProps={{
          'aria-labelledby': 'profile-button',
        }}
      >
        {' '}
        <div className="flex flex-col gap-1 px-3 py-2 text-gray-400">
          <div className="text-bold text-md"> {user?.name}</div>
          <div className="text-sm">{user?.email}</div>
          <div className="text-xs">{user?.role?.name}</div>
          <div className="text-xs">{user?.company?.name}</div>
        </div>
        <hr className="my-1" />
        {/* <MenuItem onClick={handleCloseProfile}>Profile</MenuItem>
        <MenuItem onClick={handleCloseProfile}>My account</MenuItem> */}
        <MenuItem
          onClick={() => {
            localStorage.clear();
            window.location.reload();
          }}
        >
          Logout
        </MenuItem>
      </Menu>
    </div>
  );
}

export default Component;
